import { useMembers } from "hooks/livekit/useMembers/useMembers";

export const useLocalParticipantUserId = () => {
  const { members } = useMembers();
  return members.find((m) => m.isLocalParticipant)?.userId;
};
